import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { KpiCategories, KpisByCategory, KpisByKey, MilestoneName, StageName } from '@models';

@Component({
  selector: 'kpis',
  templateUrl: './kpis.component.html',
  styleUrl: './kpis.component.scss',
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class KpisComponent implements OnChanges {
  @Input() kpisByCategory!: KpisByCategory;
  @Input() expandedGanttChartStages?: StageName[];
  @Input() keyMilestones?: MilestoneName[];

  kpisByCategoryArray!: { category: KpiCategories; kpis: KpisByKey }[];
  titleStages?: string;
  selectedView: 'table' | 'cards' = 'cards';
  private STAGE_ORDER: StageName[] = ['Startup', 'Enrollment', 'Maintenance', 'Closeout'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kpisByCategory']) {
      this.kpisByCategoryArray = Object.entries(this.kpisByCategory).map(([category, kpis]) => ({
        category: category as KpiCategories,
        kpis: kpis as KpisByKey
      }));
    }

    if (changes['expandedGanttChartStages']) {
      this.setKpisTitle();
    }
  }

  private setKpisTitle() {
    const stages = this.expandedGanttChartStages ?? [];
    if (stages.length && stages.length < this.STAGE_ORDER.length) {
      this.titleStages = ` — ${this.getStagesInTheCorrectOrder().join(', ')}`;
    } else {
      this.titleStages = undefined;
    }
  }

  private getStagesInTheCorrectOrder(): StageName[] {
    return this.STAGE_ORDER.filter((orderedStage) =>
      this.expandedGanttChartStages?.includes(orderedStage)
    );
  }

  toggleView(view: 'table' | 'cards'): void {
    this.selectedView = view;
  }
}
